import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/home.css";

const ArticleSquares = ({ article }) => {
  const navigate = useNavigate();

  const handleReadClick = (articleId) => {
    if (articleId === 1) {
      navigate("/harmonyandhearts");
    } else if (articleId === 2) {
      navigate("/inyourseat");
    } else if (articleId === 3) {
      navigate("/showchoircontests");
    } else if (articleId === 4) {
      navigate("/excellenceandsuccess");
    } else if (articleId === 5) {
      navigate("/broadway");
    } else if (articleId === 6) {
      navigate("/showdown");
    } else if (articleId === 7) {
      navigate("/harmonizinghearts");
    }
    else if (articleId === 8) {
      navigate("/harmonizingmoves");
    }
    else if (articleId === 9) {
      navigate("/recipes");
    } else if (articleId === 10) {
      navigate("/riseofshowchoir");
    } else if (articleId === 11) {
      navigate("/echoesofharmony");
    } else if (articleId === 12) {
      navigate("/celebrities");
    } else if (articleId === 13) {
      navigate("/lifeafter");
    } else if (articleId === 14) {
      navigate("/outfits")
    } else if (articleId === 15) {
      navigate("/collegeconnection");
    }
  };



  return (
    <div key={article.id} className="article-square"
      onClick={() => handleReadClick(article.id)}
    >
      <div
        className="article-square-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}${article.image})`,
        }}

      >

      </div>
      <div className="article-square-title">
        <div className="article-title-upper">
          <h4>{article.title}</h4>
          <div className="article-square-line"></div>
        </div>
        <div className="article-title-lower">
          <p className="sub-title">{article.subtitle}</p>
        </div>

        <div className="article-lower-lower">
          <div className="read-it-lbl">
            <p>Read</p>
            <img src="images/arrow-right.png" height="10px" />
          </div>
        </div>


      </div>




    </div>
  );
};

export default ArticleSquares;
